module.exports = __webpack_public_path__ + "img/left_md_3.add17415.jpg";